import React, { useMemo, useState } from 'react'

import { BreadcrumbsContext } from '../BreadcrumbsContext'

import { BreadcrumbsContextControllerProps } from './BreadcrumbsContextController.types'
import { BreadcrumbItem } from '../BreadcrumbsContext.types'

export function BreadcrumbsContextController({ children }: Readonly<BreadcrumbsContextControllerProps>) {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([])

  const breadcrumbsContextValue = useMemo(
    () => ({
      breadcrumbs,
      setBreadcrumbs
    }),
    [breadcrumbs, setBreadcrumbs]
  )

  return <BreadcrumbsContext.Provider value={breadcrumbsContextValue}>{children}</BreadcrumbsContext.Provider>
}
